import { Box } from '@primer/react';
import { useSelector } from 'react-redux';
import Page from '../../components/ui/page';
import { RootState } from '../../state/reducers';
import ThuPhiHocSinh from './ThuPhiHocSinh';
import ThuPhiTabs from './ThuPhiTabs';

const ThuPhiTabLayout = () => {
    const { selectedId } = useSelector((x: RootState) => x.thuPhiTab);
    return (
        <Page title='Thu phí'>
            <Box sx={{
                m: -3,
                mb: 2
            }}>
                <ThuPhiTabs />
            </Box>
            <Box>
                {selectedId &&
                    <ThuPhiHocSinh selectedTabId={selectedId} />
                }
            </Box>

        </Page>
    );
};

export default ThuPhiTabLayout;